import ModalInfo from 'app/common/mobile/modals/modal-info/modal-info';
import { PagePart } from 'app/modules/step-engine/utils/step-engine-constants';
import { IRootState } from 'app/shared/reducers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './disconnect.scss';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import { IconButton } from '@material-ui/core';
export interface IDisconnectComponentProps {
    icon?: boolean;
    logoutFromError?: boolean;
}

const DisconnectComponent = (props: IDisconnectComponentProps) => {
    const { icon, logoutFromError } = props || {}
    const { cmsContent } = useSelector((state: IRootState) => state.cms);
    const { claimNumber } = useSelector((state: IRootState) => state.claim);
    const { exitText, exitTextAfterDeclaration, exitCancelButton, exitValidButton } = cmsContent[PagePart.POP_IN]?.prismic || {}
    const [open, setOpen] = useState(false);
    const openModalLogOut = () => {
        setOpen(true);
    }
    const disconnectDesktop = () => {
        window.location.href = "/logout"
    }
    const closeModalLogOutDesktop = () => {
        setOpen(false);
    }
    return (
        <div >
            <div className="disconnect">
                <IconButton
                    className="disconnect-icon"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    onClick={openModalLogOut}
                    color="inherit"
                >
                    <PowerSettingsNewIcon></PowerSettingsNewIcon>
                </IconButton>
            </div>
            <ModalInfo
                modal={open}
                setModal={setOpen}
                handleOk={disconnectDesktop}
                handleCancel={closeModalLogOutDesktop}
                message={claimNumber ? exitTextAfterDeclaration : exitText}
                txtValidButton={exitValidButton}
                txtCancelButton={exitCancelButton}
            />
        </div>
    )
}

export default DisconnectComponent
